import { render } from "./CinematographyIcon.vue?vue&type=template&id=bff4314e"
import script from "./CinematographyIcon.vue?vue&type=script&lang=js"
export * from "./CinematographyIcon.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__